module.exports = __webpack_public_path__ + "img/wen style3.141e9ae6.png";